<div class="kal-calendar-header__wrapper">
  <kal-icon (click)="updateMonthAmount(-1)">
    navigate_before
  </kal-icon>

  <ng-content></ng-content>

  <kal-icon *ngIf="!isMultiView"
            (click)="updateMonthAmount(1)">
    navigate_next
  </kal-icon>

</div>
